var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6998 25.1992C18.8556 25.2944 13.5921 26.1345 9.05109 29.841C2.54318 35.1521 1.88656 43.665 1.7998 44.9992C4.56241 44.966 7.65258 44.9599 10.4152 44.9267C10.2641 43.2933 9.83485 36.8384 13.7895 31.4366C16.1199 28.2544 19.0799 25.9804 20.6998 25.1992Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5982 1.80078C21.5982 1.80078 17.2768 1.90258 14.071 4.90571C11.3101 7.49115 10.9388 10.5362 10.8521 11.412C10.4792 15.1936 12.1181 18.6877 15.198 20.9229C16.3249 21.7403 17.3995 22.2328 18.1257 22.5008C17.8559 21.5951 17.5418 20.3405 17.2981 18.8315C16.9497 16.6772 16.724 13.8821 17.2229 11.3222C18.1094 6.76657 20.2831 3.4775 21.5998 1.80078H21.5982Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5004 2.68737C17.0145 2.68737 12.5773 7.13094 12.5773 12.6C12.5773 18.0691 17.0145 22.5126 22.5004 22.5126C27.9863 22.5126 32.4235 18.0691 32.4235 12.6C32.4235 7.13094 27.9863 2.68737 22.5004 2.68737ZM9.90039 12.6C9.90039 5.63568 15.5471 0 22.5004 0C29.4537 0 35.1004 5.63568 35.1004 12.6C35.1004 19.5643 29.4537 25.2 22.5004 25.2C15.5471 25.2 9.90039 19.5643 9.90039 12.6Z",
    fill: "#60647B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 26.0984C11.639 26.0984 2.68657 35.3113 2.68657 47.6984H0C0 33.9882 9.99331 23.3984 22.5 23.3984C35.0068 23.3984 45 33.99 45 47.6984H42.3134C42.3134 35.3129 33.361 26.0984 22.5 26.0984Z",
    fill: "#60647B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0004 47.7L0.90039 47.7L0.900391 45L44.6479 45L45.0004 47.7Z",
    fill: "#60647B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#6644F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 11,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#6644F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 17,
    width: 11,
    height: 4,
    rx: 2,
    fill: "#6644F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.bd769d5f0e3da30cde3790f335d41440.svg";
export { ForwardRef as ReactComponent };